import { wsmodul_users_waiting_reducers } from "../reducers/usersWaitingRoomReducers";
import { wsmodul_status_reducers } from "../reducers/waitingRoomReducers";

const modulWaitingRoom = {
  wsmodul_users_waiting: wsmodul_users_waiting_reducers,
  wsmodul_status: wsmodul_status_reducers,
};

export default modulWaitingRoom;
